import Permit from "@/utils/permit.js";

let menus = []
menus.push({ key: 'Dashboard', label: '主工作台', path: '/normal/dashboard', icon: 'dashboard' })
menus.push({ key: "mallBargains", label: '订单', path: '/mall/mall/bargains', icon: 'oms' })
menus.push({ key: "mallProducts", label: '产品', path: '/mall/mall/products', icon: 'product' })
menus.push({ key: "mallSerials", label: '产品系列', path: '/mall/mall/serials', icon: 'serial' })
menus.push({ key: "mallCategories", label: '产品分类', path: '/mall/mall/categories', icon: 'category' })
menus.push({ key: "mallSettings", label: '全局设置', path: '/mall/mall/settings', icon: 'set' })


export default {
	items: menus.filter(menu => !menu.children || (menu.children && menu.children.length != 0)),
};